module.exports = __webpack_public_path__ + "static/racoont-43db3aecb879172cd4f22d84e9214133.png";